var MakeAppointmentDate = {
  SESSION_NAME: 'appointment_datetime',
  dateChoice: null,
  pickrOpts: {
    defaultDate: "today",
    inline: true,
    dateFormat: 'F j, Y',
    locale: {
      weekdays: {
        shorthand: ["S", "M", "T", "W", "T", "F", "S"]
      }
    },
    onChange: function (selectedDates, dateStr, instance) {
      MakeAppointmentDate.buildTimesList();
      MakeAppointmentDate.formValidation();
    },
    onReady: function (selectedDates, dateStr, instance) {
      MakeAppointmentDate.buildTimesList();
    },
    onMonthChange: function (selectedDates, datStr, instance) {
      // remove currently selected date when months are navigated
      MakeAppointmentDate.removeSelectedDate();
    },
    enable: [
      function (date) {
        return MakeAppointmentDate.flatpickrEnableDates(date);
      }
    ],
    static: true,
  },
  storeHours: null,
  storeHoursJSON: null,
  storeID: null,
  verificationBufferJSON: null,
  verificationBufferTime: null,   // Buffer time in minutes
  maxAppointmentsPerTimeSlot: null,
  calendarEndDate: null,
  savedAppointmentsObj: {},
  appointmentAvailabilityObj: [],
  brandName: "",
  hasTire: false,
  isWaiting: false,
  closeDates: Array(),
  savingAppointment: false,

  // Configuration of drop-off time windows (this is assumed local time for the shop)
  dropOffWindowConfiguration: [
    {
      label: 'MORNING',
      startHourInclusive: 8,
      startMinutes: 0,
      startHourText: 'OPEN',
      endHourExclusive: 11,
      endMinutes: 0
    },
    {
      label: 'MID-DAY',
      startHourInclusive: 11,
      startMinutes: 0,
      endHourExclusive: 13,
      endMinutes: 0
    },
    {
      label: 'AFTERNOON',
      startHourInclusive: 13,
      startMinutes: 0,
      endHourExclusive: 15,
      endMinutes: 0,
      endHourText: 'CLOSE'
    }
  ],

  init: async function (hours, verification, maxappointments, calendarend, closeddates, brand, storeid, storeJSON) {
    if (Util.getCookie('store_location') && jQuery('.make-apointment-time-picker-wrapper').length && storeJSON.AllowAppointments) {
      MakeAppointmentDate.storeData = storeJSON;
      MakeAppointmentDate.storeHoursJSON = hours;
      MakeAppointmentDate.verificationBufferJSON = verification;
      MakeAppointmentDate.closeDates = closeddates;

      MakeAppointmentDate.storeHours = hours.WaitingTires;
      MakeAppointmentDate.verificationBufferTime = verification.WaitingTires; // Convert to minutes
      MakeAppointmentDate.brandName = brand;

      MakeAppointmentDate.maxAppointmentsPerTimeSlot = maxappointments;
      MakeAppointmentDate.calendarEndDate = calendarend;
      MakeAppointmentDate.storeID = storeid;

      try {
        const endDate = new Date();
        endDate.setDate(endDate.getDate() + MakeAppointmentDate.calendarEndDate);
        MakeAppointmentDate.appointmentAvailabilityObj = await MakeAppointmentDate.getAvailableAppointmentSlotsAsync(null, endDate);
        MakeAppointmentDate.initCalendar();
      } catch (ex) {
        // Error logging handled in individual GETs above; essentially just end quietly
      }
    } else if (!storeJSON.AllowAppointments) {
      jQuery('.make-appointment-date').hide();
      jQuery('#disallow-appointments-verbiage').show();
    }

    let tireObj = (window.sessionStorage.appointment_tire) ? JSON.parse(window.sessionStorage.appointment_tire) : null;

    if (tireObj) {
      MakeAppointmentDate.hasTire = true;
    }

    // Get values from services/info step
    if (sessionStorage.getItem('appointment_services')) {
      MakeAppointmentDate.serviceSessionData = JSON.parse(sessionStorage.getItem('appointment_services'));
    }

    if (sessionStorage.getItem('appointment_tire')) {
      MakeAppointmentDate.tireSessionData = JSON.parse(sessionStorage.getItem('appointment_tire'));
    }

    if (sessionStorage.getItem('appointment_contact')) {
      MakeAppointmentDate.contactSessionData = JSON.parse(sessionStorage.getItem('appointment_contact'));
    }

    if (sessionStorage.getItem('appointment_vehicle')) {
      MakeAppointmentDate.vehicleSessionData = JSON.parse(sessionStorage.getItem('appointment_vehicle'));
    }

    hideLoadingIcon();
  },

  /**
   * Initializes calendar
   * Called after getCountOfAppointmentsPerSlot
   */
  initCalendar: function () {
    MakeAppointmentDate.dateChoice = jQuery('#date-choice').flatpickr(MakeAppointmentDate.pickrOpts);

    // default to first available appointment day
    var date = jQuery('.flatpickr-day').not('.disabled').attr('aria-label');
    MakeAppointmentDate.dateChoice.setDate(date, true);

    MakeAppointmentDate.formValidation();
    MakeAppointmentDate.formOnSubmit();
    MakeAppointmentDate.onWaitDropOffSelect();
    MakeAppointmentDate.initDateTimeSession();
    MakeAppointmentDate.initVAStateInspectionText();

    // datetime_page_load — date/time picker is now visible and ready
    window.mjtPush && window.mjtPush('datetime_page_load', {
      form_step: 2,
      form_type: 'appointment'
    });
  },

  /**
   * On change binding for stay and wait vs drop off selection
   */
  onWaitDropOffSelect: function () {
    jQuery('input[type=radio][name=additional-info]').change(function () {
      if (this.value == "wait") {
        MakeAppointmentDate.isWaiting = true;
      }
      else {
        MakeAppointmentDate.isWaiting = false;
      }
      MakeAppointmentDate.handleSettings();
      MakeAppointmentDate.buildTimesList();
      MakeAppointmentDate.formValidation();
    });
  },

  /**
   * Handle what settings to use based on if a tire is saved
   * And if the customer is choosing to wait or drop off
   */
  handleSettings: function () {
    if (MakeAppointmentDate.hasTire) {
      if (MakeAppointmentDate.isWaiting) {
        MakeAppointmentDate.storeHours = MakeAppointmentDate.storeHoursJSON.WaitingTires;
        MakeAppointmentDate.verificationBufferTime = MakeAppointmentDate.verificationBufferJSON.WaitingTires;
      }
      else {
        MakeAppointmentDate.storeHours = MakeAppointmentDate.storeHoursJSON.DropOffTires;
        MakeAppointmentDate.verificationBufferTime = MakeAppointmentDate.verificationBufferJSON.DropOffTires;
      }
    }
    else {
      if (MakeAppointmentDate.isWaiting) {
        MakeAppointmentDate.storeHours = MakeAppointmentDate.storeHoursJSON.WaitingNoTires;
        MakeAppointmentDate.verificationBufferTime = MakeAppointmentDate.verificationBufferJSON.WaitingNoTires;
      }
      else {
        MakeAppointmentDate.storeHours = MakeAppointmentDate.storeHoursJSON.DropOffNoTires;
        MakeAppointmentDate.verificationBufferTime = MakeAppointmentDate.verificationBufferJSON.DropOffNoTires;
      }
    }
  },

  /**
   * Initialize any saved session data
   */
  initDateTimeSession: function () {
    // Check to see if session key exists
    if (sessionStorage.getItem(MakeAppointmentDate.SESSION_NAME)) {
      // Parse session info
      var info = JSON.parse(sessionStorage.getItem(MakeAppointmentDate.SESSION_NAME));
      // If the session info isn't empty
      if (info.length != 0) {
        // Set calendar day to preselected date
        MakeAppointmentDate.dateChoice.setDate(info.date, true);
        // Select preselected timeslot
        jQuery("input[value='" + info.time + "']");
        jQuery("input[value='" + info.dropOffOrWait + "']");
      }

      jQuery('.make-appointment-date-time-row').fadeIn();
    }
  },

  /**
   * Handles session reset
   */
  resetSession: function () {
    if (sessionStorage.getItem(MakeAppointmentDate.SESSION_NAME)) {
      sessionStorage.removeItem(MakeAppointmentDate.SESSION_NAME);
    }
  },
  /**
   * Get date/time values from appointment
   */
  createSessionTimeObject: function () {
    // Grab values from date, time, and additional info inputs
    const dropOffOrWait = jQuery('#make-appointment-additional-info input:checked').val();
    const slot = jQuery('#make-appointment-time-picker input:checked')[0].attributes['data-slot'];
    const actualDateTime = slot.time;
    const windowStartDateTime = slot.windowStartTime;
    const windowEndDateTime = slot.windowEndTime;
    const monthStr = new Intl.DateTimeFormat('en', { month: 'long' }).format(actualDateTime);
    const weekdayStr = new Intl.DateTimeFormat('en', { weekday: 'long' }).format(actualDateTime);

    // Use a hour and minute if provided, otherwise fall back on label/text
    const startTimeText = windowStartDateTime
      ? Intl.DateTimeFormat('en', { hour: 'numeric', minute: 'numeric', hour12: true }).format(windowStartDateTime)
      : slot.startHourText;

    // Use a hour and minute if provided, otherwise fall back on label/text
    const endTimeText = windowEndDateTime
      ? Intl.DateTimeFormat('en', { hour: 'numeric', minute: 'numeric', hour12: true }).format(windowEndDateTime)
      : slot.endHourText;
    
    // Format date for summary sidebar view
    let sessionDateString =
      weekdayStr + ', ' + monthStr + ' ' + actualDateTime.getDate() + ((!windowStartDateTime || !windowEndDateTime) ?
        " at " + Intl.DateTimeFormat('en', { hour: 'numeric', minute: 'numeric', hour12: true }).format(actualDateTime) :
        " between " + startTimeText + " and " + endTimeText);

    return {
      dropOffOrWait: dropOffOrWait,
      actualDateTime: actualDateTime,
      sessionDateString: sessionDateString
    }
  },

  /**
   * Handles form on submit
   * Stores session info into appointment_datetime
   */
  formOnSubmit: function () {
    // Set up an event listener
    jQuery('#make-appointment-date-form').submit(function (event) {
      event.preventDefault();
      let sessionTimeObject = MakeAppointmentDate.createSessionTimeObject();
      // Construct object array (Array for consistency)
      let sessionInfo = {
        "text": sessionTimeObject.sessionDateString,
        "isoDateTime": sessionTimeObject.actualDateTime.toISOString(),
        "dropOffOrWait": sessionTimeObject.dropOffOrWait,
        "services": MakeAppointmentDate.services,
        "storeData": MakeAppointmentDate.storeData,
      };

      // Set session value
      MakeAppointmentDate.setDateTimeSession(sessionInfo);

      MakeAppointmentCurrentPage.appointmentFlow.locationDatetime = true;
      MakeAppointmentCurrentPage.updateAppointmentFlowSession();

      // form_submit event for date/time selection
      window.mjtPush && window.mjtPush('form_submit', {
        form_type:        'appointment',
        store_location:   MakeAppointmentDate.storeData ? (MakeAppointmentDate.storeData.Id || '') : '',
        appointment_date: sessionTimeObject.sessionDateString || ''
      });

      if (!MakeAppointmentDate.savingAppointment) {
        MakeAppointmentDate.savingAppointment = true;
        MakeAppointmentDate.saveAppointment();
      }
    });
  },

  /**
   * Sets the appointment_datetime in sessionStorage
   */
  setDateTimeSession: function (sessionInfo) {
    let info = JSON.stringify(sessionInfo);
    sessionStorage.setItem(MakeAppointmentDate.SESSION_NAME, info);
  },

  /**
   * Handles form validation
   * Displays bootstrap error if missing required fields
   */
  formValidation: function () {
    // Setup and event listener
    jQuery('#make-appointment-date-form input').on("invalid", function (event) {
      // Prevent default event handler
      event.preventDefault();

      //hide loading icon
      hideLoadingIcon();

      // Get the input name that is invalid
      let input = event.srcElement.name;

      // For missing additional info
      if (input === 'additional-info') {
        jQuery('#form-invalid-additional-info').fadeIn();
      }
      // For missing time
      if (input === 'appointment-time') {
        jQuery('#form-invalid-date-time').fadeIn();
      }
    });

    // Fade out bootstrap errors if inputs are changed
    jQuery('#make-appointment-time-picker input').change(function () {
      jQuery('#form-invalid-date-time').fadeOut();
    });

    jQuery('#make-appointment-additional-info input').change(function () {
      jQuery('#form-invalid-additional-info').fadeOut();
    });
  },

  /* Function */
  saveAppointment: function () {
    let services = '';
    let sessionTimeObject = MakeAppointmentDate.createSessionTimeObject();

    if (MakeAppointmentDate.serviceSessionData && MakeAppointmentDate.serviceSessionData.length) {
      services = MakeAppointmentDate.serviceSessionData
        .map(svc => svc['name'])
        .reduce((prev, cur) => prev + ', ' + cur);
    }

    const timeSlot = jQuery('#make-appointment-time-picker input:checked')[0].attributes['data-slot'];
    const timeStr =
      `${timeSlot.time.getFullYear()}-${timeSlot.time.getMonth() + 1}-${timeSlot.time.getDate()} ` +
      `${timeSlot.time.getHours().toString().padLeft(2, 0)}:${timeSlot.time.getMinutes().toString().padLeft(2, 0)}:00`

    var dataObj = {
      "PreferredTime2": timeStr,
      "PreferredTime1": timeStr,
      "apptDateString": sessionTimeObject.sessionDateString,
      "FirstName": MakeAppointmentDate.contactSessionData.firstName,
      "LastName": MakeAppointmentDate.contactSessionData.lastName,
      "Email": MakeAppointmentDate.contactSessionData.email,
      "Phone": MakeAppointmentDate.contactSessionData.phone,
      "AltPhone": MakeAppointmentDate.contactSessionData.altPhone,
      "OptInPromotion": MakeAppointmentDate.contactSessionData.optInPromotion,
      "IsVperksCampaign": MakeAppointmentDate.contactSessionData.isVperksCampaign,
      "AppointmentSource": MakeAppointmentDate.contactSessionData.appointmentSource,
      "Comments": MakeAppointmentDate.contactSessionData.comments,
      "Brand": MakeAppointmentDate.storeData.DisplayName,
      "BrandDisplayName": MakeAppointmentDate.storeData.BrandDisplayName,
      "BrandId": MakeAppointmentDate.storeData.BrandId,
      "BrandInternalId": Util.lookupInternalBrandIds(MakeAppointmentDate.storeData.BrandId),
      "StoreId": '' + MakeAppointmentDate.storeData.Id,
      "Address": MakeAppointmentDate.storeData.Address,
      "City": MakeAppointmentDate.storeData.City,
      "State": MakeAppointmentDate.storeData.StateName,
      "ZipCode": MakeAppointmentDate.storeData.ZipCode,
      "StorePhone": MakeAppointmentDate.storeData[Util.getDniColumn()],
      "DeliveryType": jQuery('#make-appointment-additional-info input:checked').val(),
      "Year": MakeAppointmentDate.vehicleSessionData.year,
      "Make": MakeAppointmentDate.vehicleSessionData.make,
      "Model": MakeAppointmentDate.vehicleSessionData.model,
      "Option": MakeAppointmentDate.vehicleSessionData.option,
      "Tires": MakeAppointmentDate.tireSessionData, // From Tire Details Page
      "Services": '',
      "AdditionalServices": services,
      "ZoneId": '' + MakeAppointmentDate.storeData.ZoneId,
      "MarketId": '' + MakeAppointmentDate.storeData.MarketId,
      "TimeZoneId": '' + MakeAppointmentDate.storeData.TimeZoneId,
      "HasInternet": MakeAppointmentDate.storeData.HasInternet ? "true" : "false",
      "SourceType": '8',
      "VehicleId": 85378
    }

    sessionStorage.setItem('appointment_summary', JSON.stringify(dataObj));
    sessionStorage.setItem('prefTime', jQuery('#make-appointment-time-picker input:checked')[0].attributes['data-slot'].time);
    // Remove data fields that are null or empty
    jQuery.each(dataObj, function (key, val) {
      if (val === null || val === '') {
        delete dataObj[key];
      }
    });

    // Post request
    let req = jQuery.ajax({
      url: Util.lambdaHostAppt + '/createAppointment',
      beforeSend: function (request) {
        request.setRequestHeader('x-api-key', Util.lambdaApiKeyAppt);
      },
      dataType: 'json',
      type: "POST",
      data: JSON.stringify(dataObj),
      contentType: "application/json;charset=utf-8",
      success: function (response) {
        // Update session flow
        MakeAppointmentCurrentPage.appointmentFlow.dateTime = true;
        MakeAppointmentCurrentPage.updateAppointmentFlowSession();
        MakeAppointmentCurrentPage.savingAppointment = false;
        MakeAppointmentDate.emailAppointment(response.AppointmentID);

        // API does not return an AppointmentID — generate a client-side UUID
        // so appointment_scheduled and generate_lead can be correlated
        var confirmationId = response.AppointmentID || (crypto && crypto.randomUUID ? crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16); }));
        sessionStorage.setItem('mjt_confirmation_id', confirmationId);

        // form_steps step 2 + conversion events
        window.mjtPush && window.mjtPush('form_steps', {
          form_step: 2,
          step_name: 'date_time',
          form_type: 'appointment'
        });
        window.mjtPush && window.mjtPush('appointment_scheduled', {
          confirmation_id:   confirmationId,
          appointment_date:  dataObj.apptDateString || '',
          tire_sku:          dataObj.Tires ? (dataObj.Tires.sku || '') : ''
        });
        window.mjtPush && window.mjtPush('generate_lead', {
          confirmation_id: confirmationId,
          lead_type:       'appointment'
        });
        sessionStorage.setItem('mjt_action_taken', 'true');
      },
      error: function (response) {
        console.log(response);
        MakeAppointmentCurrentPage.savingAppointment = false;
      }
    });
  },

  emailAppointment: function (appointmentId) {
    let currentTime = new Date().toLocaleDateString('en-US', {
      hour: "numeric",
      minute: "2-digit"
    });

    let requestedTimeText;
    const slot = jQuery('#make-appointment-time-picker input:checked')[0].attributes['data-slot'];
    const windowStartDateTime = slot.windowStartTime;
    const windowEndDateTime = slot.windowEndTime;

    // date of appointment in MM/DD/YY string format - ternary statement because drop off and stay and wait have different defined variables
    const appointmentDateString = 
      windowStartDateTime ? 
      windowStartDateTime.getMonth() + 1 + '/' + windowStartDateTime.getDate() + '/' + windowStartDateTime.getFullYear(): // drop off
      slot.time.getMonth() + 1 + '/' + slot.time.getDate() + '/' + slot.time.getFullYear(); // stay and wait

    if (slot.windowStartTime && slot.windowEndTime) {
      // Use a hour and minute if provided, otherwise fall back on label/text
      const startTimeText = windowStartDateTime
        ? Intl.DateTimeFormat('en', { hour: 'numeric', minute: 'numeric', hour12: true }).format(windowStartDateTime)
        : slot.startHourText;

      // Use a hour and minute if provided, otherwise fall back on label/text
      const endTimeText = windowEndDateTime
        ? Intl.DateTimeFormat('en', { hour: 'numeric', minute: 'numeric', hour12: true }).format(windowEndDateTime)
        : slot.endHourText;

      requestedTimeText = startTimeText + ' - ' + endTimeText;
    } else {
      requestedTimeText = MakeAppointmentDate.formatTimeString(slot.time.toTimeString());
    }

    let services = '[]';
    if (MakeAppointmentDate.serviceSessionData && MakeAppointmentDate.serviceSessionData.length) {
      services = JSON.stringify(MakeAppointmentDate.serviceSessionData.map(svc => svc['name']));
    }

    let apptInfo = {
      "dropOffOrWait": jQuery('#make-appointment-additional-info input:checked').val(),
      "requestedDate": appointmentDateString,
      "requestedTime": requestedTimeText,
      "vehicleYear": MakeAppointmentDate.vehicleSessionData.year,
      "vehicleMake": MakeAppointmentDate.vehicleSessionData.make,
      "vehicleModel": MakeAppointmentDate.vehicleSessionData.model,
      "vehicleOption": MakeAppointmentDate.vehicleSessionData.option,
      "services": services,
      "comment": MakeAppointmentDate.contactSessionData.comments,
      "phone": MakeAppointmentDate.contactSessionData.phone,
      "currentTime": currentTime.replace(',', ''), //remove any commas
      "isVperksCampaign": Util.getCookie("vperks_google_ads_campaign")
    };

    let tireObj = MakeAppointmentDate.tireSessionData;
    let tireInfo = null;
    if (tireObj) {
      //total the feeTotals within each fee object in the fee array
      //the fee total is being converted to a string, so parse it back to a decimal
      let feeTotal = tireObj.fees.length ? tireObj.fees.map(item => item.feeTotal).reduce((prev, next) => parseFloat(prev) + parseFloat(next)) : 0;
      let makeModel = tireObj.makeModel.split(' - ');

      tireInfo = {
        "image": tireObj.image,
        "quantity": tireObj.qty,
        "sku": tireObj.sku,
        "size": tireObj.size,
        "make": makeModel[0],
        "model": makeModel[1],
        "perTire": (tireObj.tireOnlyPrice / tireObj.qty).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
        "subtotal": tireObj.subtotal,
        "total": tireObj.total,
        "fees": tireObj.fees,
        "feeTotal": feeTotal,
        "discountRuleId": null,
        "discountDesc": tireObj.tireRebateDescription,
        "promoDiscount": tireObj.tireRebate,
        "type": tireObj.type
      };
    }

    let toAddresses = [];
    if (MakeAppointmentDate.contactSessionData.email) {
      toAddresses.push(MakeAppointmentDate.contactSessionData.email);
    }

    jQuery.ajax({
      url: window.location.origin + '/wp-json/monro/v1/email/appointment',
      type: 'POST',
      data: {
        to: toAddresses,
        template: 'appointment-quote',
        firstName: MakeAppointmentDate.contactSessionData.firstName,
        lastName: MakeAppointmentDate.contactSessionData.lastName,
        isVperksCampaign: MakeAppointmentDate.contactSessionData.isVperksCampaign,
        tireInfo: tireInfo,
        apptInfo: apptInfo
      },
      complete: function (response) {
        MakeAppointmentServicesInfo.savingAppointment = false;
        // if (response.status == 200) {
          window.location = window.location.origin + '/appointment/summary?prefTime=' + encodeURIComponent(requestedTimeText);
        // }
      },
    });
  },

  /**
   * Determines if there are available appointment slots for today.
   */
  appointmentsAvailableToday: function () {
    // functionality to disable appointments in the "past" has been removed due to time zone issues.
    // We are now dependent on the Monro Appointment API for when to show appointments. 
    var verificationDateTime = new Date();
    verificationDateTime.setMinutes(verificationDateTime.getMinutes() + MakeAppointmentDate.verificationBufferTime + 30);

    var hours = MakeAppointmentDate.storeHours[verificationDateTime.getDay()];

    const today = new Date();
    const isApptsToday = MakeAppointmentDate.appointmentAvailabilityObj.some(apptInfo => {
      const apptDate = new Date(apptInfo.StartTime)
      return (
        apptDate.getFullYear() == today.getFullYear() &&
        apptDate.getMonth() == today.getMonth() &&
        apptDate.getDate() == today.getDate()
      )
    })

    if (!isApptsToday) {
      return false;
    }

    // Disable if store is closed
    if (hours.open === hours.close) {
      return false;
    }

    return true;
  },

  /**
   * Calculates the dates to enable for selection in a flatpickr instance
   * Enables today through the number of days passed in
   * 
   * @param {*} date The date to check
   * @param {number} days The number of future days to allow
   * 
   * @return {bool} True if enabled, otherwise false.
   */
  flatpickrEnableDates: function (date) {
    var today = new Date(new Date().toDateString());
    var hours = MakeAppointmentDate.storeHours[date.getDay()];

    // Disable if store is closed
    if (hours.open === hours.close) {
      return false;
    }

    // Disable if there is a closed date from the appointment closed date admin
    if (MakeAppointmentDate.closeDates.some(item => item.Date === date.toISOString().split('T')[0])) {
      return false;
    }

    // Enable current date if appointments available today
    if (MakeAppointmentDate.appointmentsAvailableToday()) {
      return (date >= today && date < today.setDate(today.getDate() + MakeAppointmentDate.calendarEndDate));
    }
    // Disable current date if appointments unavailable today
    else {
      return (date > today && date < today.setDate(today.getDate() + MakeAppointmentDate.calendarEndDate));
    }

    return (date >= today && date < today.setDate(today.getDate() + MakeAppointmentDate.calendarEndDate));

  },

  /**
   * Build dictionary of saved appointment counts
   */
  buildSavedApptsDict: function (response) {
    jQuery(response).each(function (i, k) {
      var date = new Date(k.date);
      MakeAppointmentDate.savedAppointmentsObj[date] = k.count;
    });
  },

  /**
   * Determine if time slot is still available
   * Uses max appointments per time slot from brand/appt settings
   */
  isTimeSlotAvailable: function (date) {
    if (MakeAppointmentDate.savedAppointmentsObj[date] >= MakeAppointmentDate.maxAppointmentsPerTimeSlot) {
      return false;
    }
    return true;
  },

  /* Function */
  getCountOfAppointmentsPerSlotAsync: function () {
    var dataObj = {
      "storeid": MakeAppointmentDate.storeID,
      "brand": "\"" + MakeAppointmentDate.brandName + "\"",
      "howmanydays": MakeAppointmentDate.calendarEndDate
    }

    return new Promise((resolve, reject) => {
      jQuery.ajax({
        url: Util.lambdaHost + 'appointment/lookup',
        beforeSend: function (request) {
          request.setRequestHeader('x-api-key', Util.lambdaApiKey);
        },
        dataType: 'json',
        type: "GET",
        data: dataObj,
        contentType: "application/json;charset=utf-8",
        success: function (response) {
          // Build dictionary of saved appointments from endpoint
          MakeAppointmentDate.buildSavedApptsDict(response);
          resolve();
        },
        error: function (response) {
          console.log(response);
          reject();
        }
      });
    });
  },

  /**
   * Return available appointments slots for a V2 store, from startDate (inclusive) to
   * endDate (exclusive). If the store is not a V2 store, this will resolve to
   * `undefined`; while if the store is a V2 store but has no slots, this will resolve
   * an empty array.
   * @param {*} startDate Inclusive start date of range
   * @param {*} endDate Exclusive end date of range
   * @returns Array of appointment slot objects if the store is a V2 store; undefined if
   *          the store is not a V2 store.
   */
  getAvailableAppointmentSlotsAsync: function (startDate, endDate) {
    const params = { storeId: MakeAppointmentDate.storeID };

    if (startDate) {
      params.startTime = startDate.toISOString();
    }

    return new Promise((resolve, reject) => {
      jQuery.ajax({
        url: Util.lambdaHostAppt + 'getappointments',
        beforeSend: function (request) {
          request.setRequestHeader('x-api-key', Util.lambdaApiKeyAppt);
        },
        dataType: 'json',
        type: "GET",
        data: params,
        contentType: "application/json;charset=utf-8",
        success: async function (response) {
          // Only stores using V2 will actually return appointment data, even if
          // it is just an empty array. V1 stores will return no response at all.
          if (response && response.AppointmentTime) {
            if (response.AppointmentTime.length) {
              // If we got appointments back; add them to our collection and then
              // see if we need to add further date ranges to meet our end date.
              let availableSlots = response.AppointmentTime;

              // Do we need to ask for more slots? Find the last appointment slot
              // date we already have, bump it out to the next day, and send out
              // another request starting at that date.
              const lastDate = new Date(Math.max(...availableSlots.map(slot => new Date(slot.StartTime).getTime())));
              if (lastDate <= endDate) {
                const nextDate = new Date(lastDate.getTime());
                nextDate.setHours(0, 0, 0, 0);
                nextDate.setDate(nextDate.getDate() + 1);

                // Recursively go further out in the date range
                availableSlots = availableSlots.concat(await MakeAppointmentDate.getAvailableAppointmentSlotsAsync(nextDate, endDate));
              }

              resolve(availableSlots);
            } else {
              // No more dates available
              resolve([]);
            }
          }

          // Resolve as undefined, implying this store is not using the V2 flow
          resolve();
        },
        error: function (response) {
          if (response.status === 400) {
            // Resolve as undefined, implying this store is not using the V2 flow
            resolve();
          } else {
            console.error('Exception occured while retrieving available appointment times', response);
            reject();
          }
        }
      });
    });
  },

  /**
   * Builds lists of times to select from for both drop-off and "stay and wait"
   */
  buildTimesList: function () {
    // Get the date input for the column
    var selectedDateString = jQuery('#date-choice').val();

    // Ensure a date is set
    if (selectedDateString !== '') {
      // Sets the open and close window time for drop off
      var selectedDateValue = new Date(selectedDateString);
      var actualStoreOpen = MakeAppointmentDate.storeHoursJSON.DropOffWindow[selectedDateValue.getDay()].open;
      var actualStoreClose = MakeAppointmentDate.storeHoursJSON.DropOffWindow[selectedDateValue.getDay()].close;
      var openDate = new Date(Date.parse(selectedDateString + ' ' + actualStoreOpen));
      var closeDate = new Date(Date.parse(selectedDateString + ' ' + actualStoreClose));
      MakeAppointmentDate.dropOffWindowConfiguration[0].startHourInclusive = openDate.getHours();
      MakeAppointmentDate.dropOffWindowConfiguration[0].startMinutes = openDate.getMinutes();
      MakeAppointmentDate.dropOffWindowConfiguration[2].endHourExclusive = closeDate.getHours();
      MakeAppointmentDate.dropOffWindowConfiguration[2].endMinutes = closeDate.getMinutes();

      var nextDateValue = new Date(selectedDateValue.getTime());
      nextDateValue.setDate(nextDateValue.getDate() + 1);
      nextDateValue.setHours(0, 0, 0, 0);

      let stayAndWaitTimeSlots;
      let dropOffTimeSlots;

      // New appointment flow
      if (MakeAppointmentDate.appointmentAvailabilityObj) {
        const isStateInspection =
          MakeAppointmentDate.serviceSessionData &&
          MakeAppointmentDate.serviceSessionData.length &&
          MakeAppointmentDate.serviceSessionData.some(service => service.id.includes('-StateInspection'));

        stayAndWaitTimeSlots = MakeAppointmentDate.appointmentAvailabilityObj
          .filter(slot => Boolean(slot))
          .filter(slot => !isStateInspection || slot.StateInspection == true)
          .map(currentTime => ({
            time: new Date(currentTime.StartTime)
          }))
          .sort((timeA, timeB) => timeA.time - timeB.time)
          .filter(currentTime => {
            return currentTime.time >= selectedDateValue && currentTime.time < nextDateValue;
          })
          .map(currentTime => ({
            ...currentTime,
            isAvailable: true
          }));

        dropOffTimeSlots = MakeAppointmentDate.dropOffWindowConfiguration
          // Only include a drop off slot if at least one stay and wait slot exists between start and end
          // Also include the "actual" time that points back to a real stay and wait slot
          .map(slot => {
            const windowStartTime = new Date(selectedDateValue.getTime());
            windowStartTime.setHours(slot.startHourInclusive);
            windowStartTime.setMinutes(slot.startMinutes);

            const windowEndTime = new Date(selectedDateValue.getTime());
            windowEndTime.setHours(slot.endHourExclusive);
            windowEndTime.setMinutes(slot.endMinutes);

            const actualTimeSlot = stayAndWaitTimeSlots.find(s =>
              s.time.getHours() >= slot.startHourInclusive &&
              s.time.getHours() < slot.endHourExclusive);

            return {
              ...slot,
              windowStartTime: windowStartTime,
              windowEndTime: windowEndTime,
              time: actualTimeSlot ? actualTimeSlot.time : null
            };
          })
          .filter(slot => !!slot.time)
      }
      // Old appointment flow
      else {
        stayAndWaitTimeSlots = [];

        // Get the selected date and create date objs for the store start and open times.
        var selectedDate = new Date(selectedDateString);
        var open = MakeAppointmentDate.storeHours[selectedDate.getDay()].open;
        var close = MakeAppointmentDate.storeHours[selectedDate.getDay()].close;
        var min = MakeAppointmentDate.storeHours[selectedDate.getDay()].min;
        var max = MakeAppointmentDate.storeHours[selectedDate.getDay()].max;

        var openDate = new Date(Date.parse(selectedDateString + ' ' + open));
        var closeDate = new Date(Date.parse(selectedDateString + ' ' + close));
        var minDate = new Date(Date.parse(selectedDateString + ' ' + min));
        var maxDate = new Date(Date.parse(selectedDateString + ' ' + max));

        // Calculate verificationTime
        var verificationDate = new Date();
        verificationDate.setMinutes(verificationDate.getMinutes() + MakeAppointmentDate.verificationBufferTime)

        // Iterate
        while (openDate < closeDate) {
          // Determine if appointment is available or not
          var isAvailable = openDate >= minDate && openDate < maxDate;
          isAvailable = isAvailable && openDate > verificationDate;
          isAvailable = isAvailable && MakeAppointmentDate.isTimeSlotAvailable(openDate);

          stayAndWaitTimeSlots.push({
            time: new Date(openDate.getTime()),
            isAvailable: isAvailable
          });

          // Increment by half-hour
          openDate.setMinutes(openDate.getMinutes() + 30);
        }

        dropOffTimeSlots = MakeAppointmentDate.dropOffWindowConfiguration
          .map(slot => {
            const actualTime = new Date(selectedDateValue.getTime());
            actualTime.setHours(slot.startHourInclusive);
            actualTime.setMinutes(slot.startMinutes);

            const windowEndTime = new Date(selectedDateValue.getTime());
            windowEndTime.setHours(slot.endHourExclusive);
            windowEndTime.setMinutes(slot.endMinutes);

            return {
              ...slot,
              windowStartTime: actualTime,
              windowEndTime: windowEndTime,
              time: actualTime
            };
          });
      }
      MakeAppointmentDate.renderTimesLists(dropOffTimeSlots, stayAndWaitTimeSlots);
    }
  },

  renderTimesLists: function (dropOffTimeSlots, stayAndWaitTimeSlots) {
    //
    // Drop off times
    const dropCol = jQuery('.drop-options');

    dropCol.empty();
    // if there are any appointments of a given day
    if(dropOffTimeSlots.length) {
      dropOffTimeSlots.forEach(slot => {
        // Use hour if it is present, otherwise fall back on lable
        const startTimeText = MakeAppointmentDate.formatTimeString(slot.windowStartTime.toTimeString())
          ? MakeAppointmentDate.formatTimeString(slot.windowStartTime.toTimeString())
          : slot.startHourText;
  
        // Use hour if it is present, otherwise fall back on lable
        const endTimeText = MakeAppointmentDate.formatTimeString(slot.windowEndTime.toTimeString())
          ? MakeAppointmentDate.formatTimeString(slot.windowEndTime.toTimeString())
          : slot.endHourText;
  
        const actualTimeVal = new Date(slot.time.getTime()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  
        const slotElement = jQuery(`
          <label class='drop-button monro-button-yellow'>
            <input type='radio' name='appointment-time' value='${actualTimeVal}' required='required'>
              <span style='border-radius: 12px; font-size: 1rem;'>
                ${slot.label} <p style='font-size: 0.8rem; margin: 0;'>${startTimeText} - ${endTimeText}</p>
              </span>
            </input>
          </label>`);
  
        slotElement.children('input').get()[0].attributes['data-slot'] = slot;
  
        // These are always rendered regardless of current drop off / wait selection; but will
        // be hidden by the outer div, .drop-options, for stay and wait mode.
        dropCol.append(slotElement);
        jQuery('.no-appointment-available-verbiage').hide();
        jQuery('.no-date-selected-verbiage').hide();
        jQuery('.make-apointment-time-picker-wrapper').show();
        MakeAppointmentDate.enableScheduleAppointmentButton();
      });
    } else {
      jQuery('.no-appointment-available-verbiage').show();
      jQuery('.no-date-selected-verbiage').hide();
      jQuery('.make-apointment-time-picker-wrapper').hide();
      MakeAppointmentDate.disableScheduleAppointmentButton();
    }

    // Get the first column
    var col = jQuery('.make-appointment-time-col-0');

    // Empty all three columns
    jQuery('.make-appointment-time-col-0').empty();
    jQuery('.make-appointment-time-col-1').empty();
    jQuery('.make-appointment-time-col-2').empty();
    jQuery('.make-appointment-time-col-3').empty();
    jQuery('.make-apointment-time-picker-wrapper').hide();

    // Calculate how many appointment slots show display per column to be evenly distributed
    var maxAppointmentSlotsInCol = Math.ceil(stayAndWaitTimeSlots.length / 4);
    var colCounter = 0;
    var appointmentSlotsInColCounter = 0;

    stayAndWaitTimeSlots.forEach(currentTime => {
      // Isolate time
      const timeString = currentTime.time.toTimeString();
      const time = MakeAppointmentDate.formatTimeString(timeString);
      const timeVal = new Date(currentTime.time.getTime()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

      // If reached max amount of slots in current col, use next column
      if (appointmentSlotsInColCounter == maxAppointmentSlotsInCol) {
        appointmentSlotsInColCounter = 0;
        colCounter++;
        col = jQuery('.make-appointment-time-col-' + colCounter)
      }

      const slotElement = jQuery('<label />')
      const slotInput = jQuery('<input />', {
        type: "radio",
        name: "appointment-time",
        value: timeVal,
        required: true,
        ... (!currentTime.isAvailable ? { disabled: true } : undefined)
      });

      slotInput[0].attributes['data-slot'] = currentTime;

      slotElement.append(
        slotInput,
        currentTime.isAvailable ? jQuery('<span>').text(time) : jQuery('<span>', { text: time, class: "disabled" }).append(jQuery('<div>', { text: "*", style: "display:inline;color:#666;" })));

      // Append appointment slot to current column
      col.append(slotElement)
      jQuery('.make-apointment-time-picker-wrapper').fadeIn('slow');

      appointmentSlotsInColCounter++;
    });
  },

  /**
   * Formats a Date.toTimeString() as a human readable time.
   * 
   * @param {string} timeString A string as output by Date.toTimeString()
   * 
   * @return {string} A human-readable string representing the time
   */
  formatTimeString: function (timeString) {
    // Extract hours and minutes
    var hours = parseInt(timeString.substr(0, 2));
    var mins = timeString.substr(3, 2);
    var meridian;

    // Calculate meridian and convert to 12hr
    if (hours < 12) {
      meridian = 'AM';
    } else {
      if (hours !== 12) {
        hours -= 12;
      }
      meridian = 'PM';
    }

    // Create human friendly string
    // return hours + ':' + padNumber(mins, 2) + meridian;
    return hours + ':' + mins + meridian;
  },

  /** Removes selected date and sets proper verbiage */
  removeSelectedDate: function () {
    MakeAppointmentDate.dateChoice.setDate(null, null);
    jQuery('.no-appointment-available-verbiage').hide();
    jQuery('.make-apointment-time-picker-wrapper').hide();
    jQuery('.no-date-selected-verbiage').show();
    MakeAppointmentDate.disableScheduleAppointmentButton();
  },

  disableScheduleAppointmentButton: function() {
    jQuery('.make-appointment-next-btn').prop('disabled', true);
    jQuery('.make-appointment-next-btn').css('cursor', 'default');
    jQuery('.make-appointment-next-btn').removeClass('monro-button-yellow');
  },

  enableScheduleAppointmentButton: function() {
    jQuery('.make-appointment-next-btn').prop('disabled', false);
    jQuery('.make-appointment-next-btn').css('cursor', 'pointer');
    jQuery('.make-appointment-next-btn').addClass('monro-button-yellow');
  },

  initVAStateInspectionText: function() {
    jQuery('.make-appointment-additional-info-label').click(function() {
      let appointmentServices = JSON.parse(sessionStorage.getItem('appointment_services'));
      if (MakeAppointmentDate.storeData['StateCode'] == 'VA' && appointmentServices[0]['name'] == 'State Inspection') {
        jQuery(".va-state-inspection-verbiage").show();
      }
    });
  }
};